<template>
  <div>

    <v-card
       elevation="0"
       class="pa-4"
    >
      <div class="d-flex align-center">
        <h3>Relatório de recebimentos</h3>
        <v-spacer></v-spacer>
        </div>
    </v-card>

    <v-divider class="ma-2"></v-divider>
    <v-data-table
        :items="productSales"
        :loading="prdloading"
        :headers="prdHeaders"
        class="content-table"
        hide-default-footer
        style="cursor: pointer"
        loading-text="Buscando..."
        no-data-text="Sem registros"
        @click:row="handleRowClick"
    >
      <template v-slot:[`header.download`]="{ header }">
        <v-btn
            outlined
            tile
            icon
            width="35"
            height="35"
            v-on="header"
            class="quinary-button"
            style="border-radius: 4px"
            @click="generateExcel()"
        >
          <v-icon>mdi-download-outline</v-icon>
        </v-btn>
      </template>

      <template v-slot:[`item.orderCode`]="{ item }">
        <span>
          {{ item.orderCode }}
        </span>
      </template>

      <template v-slot:[`item.client.name`]="{ item }">
        <span>
          {{ item.client.name }}
        </span>
      </template>

      <template v-slot:[`item.paymentMethod`]="{ item }">
        <span v-if="item.paymentMethod === 0">
          Cartão de credito
        </span>
        <span v-else-if="item.paymentMethod === 1">
          Boleto bancário
        </span>
        <span v-else>
          Pix
        </span>
      </template>

      <template v-slot:[`item.creditInstallments`]="{ item }">
        <span v-if="item.paymentMethod === 0">
          {{item.creditInstallments}} <strong>X</strong>
        </span>
        <span v-else>
          -
        </span>
      </template>

      <template v-slot:[`item.transactionSummary`]="{ item }">
        <span v-if="item.transactionSummary && item.transactionSummary.status && item.transactionSummary.status === 'paid'">
          {{
            (item.resaleValueReceiveSplit).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>

        <span v-else>
          {{
            (0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>
      </template>

      <template v-slot:[`item.totalFees`]="{ item }">
        <span v-if="item.transactionSummary && item.transactionSummary.status && item.transactionSummary.status === 'paid'">
          {{
            item.totalFees.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>

        <span v-else>
          {{
            (0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>
      </template>

      <template v-slot:[`item.commission`]="{ item }">
        <span v-if="item.commission">
          {{
            item.commission.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>

        <span v-else>
          {{
            (0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>
      </template>

      <template v-slot:[`item.netValue`]="{ item }">
        <span v-if="item.transactionSummary && item.transactionSummary.status && item.transactionSummary.status === 'paid'">
          {{
            (Number(item.resaleValueReceiveSplit) - Number(item.totalFees) - Number(item.processingCost)).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>

        <span v-else>
          {{
            (0).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </span>
      </template>

      <template v-slot:[`item.transactionSummaryStatus`]="{ item }">
        <span class="aguardando"
           v-if="item.transactionSummary && item.transactionSummary.charges && item.transactionSummary.charges.length > 0 &&
           (item.transactionSummary.charges[0].status === 'pending' || item.transactionSummary.charges[0].status === 'processing')">
          Aguardando
        </span>

        <span class="aprovado" v-else-if="item.transactionSummary && item.transactionSummary.charges && item.transactionSummary.charges.length > 0 && item.transactionSummary.charges[0].status === 'paid'">
          Aprovado
        </span>

        <span class="cancelado" v-else-if="item.transactionSummary && item.transactionSummary.charges && item.transactionSummary.charges.length > 0 &&
        (item.transactionSummary.charges[0].status === 'canceled'  || item.transactionSummary.charges[0].status === 'failed')">
          Reprovado
        </span>

        <span class="cancelado" v-else-if="item.transactionSummary && item.transactionSummary.charges && item.transactionSummary.charges.length > 0 && item.transactionSummary.charges[0].status === 'chargedback'">
          Reembolsado
        </span>

        <span v-else>
          -
        </span>
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "ReceiptReportsDashResale",
  components: {Pagination},

  props: {
    filter: {
      resaleId: "",
      startDate: "",
      endDate: "",
    },
  },

  data() {
    return {
      productSales: [],
      page: 1,
      pageSize: 10,
      currentPage: 1,
      totalItems: 1,
      totalPages: 1,
      prdHeaders: [
        {
          text: "Pedido",
          align: "center",
          value: "orderCode",
          sortable: false,
        },
        {
          text: "Cliente",
          align: "center",
          value: "client.name",
          sortable: false,
        },
        {
          text: "Forma de pagamento",
          align: "center",
          value: "paymentMethod",
          sortable: false,
        },
        {
          text: "Parcelamento",
          align: "center",
          value: "creditInstallments",
          sortable: false,
        },
        {
          text: "Total do pedido",
          align: "center",
          value: "transactionSummary",
          sortable: false,
        },
        {
          text: "Taxa de transação",
          align: "center",
          value: "totalFees",
          sortable: false,
        },
        {
          text: "Comissão",
          align: "center",
          value: "commission",
          sortable: false,
        },
        {
          text: "Valor liquído",
          align: "center",
          value: "netValue",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          value: "transactionSummaryStatus",
          sortable: false,
        },
        {
          align: "center",
          sortable: false,
          value: "download",
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },
      prdloading: false,
      apiService: new ApiService(),
    };
  },

  async created() {
    await this.getRransactionSummary();
  },

  methods: {
    async generateExcel() {
      this.loading = true;

      let now = new Date();
      const filename =
          `relatorioRecebimentos` +
          `${now.getDate()}-${now.getMonth() + 1}-${now.getFullYear()}.xlsx`;

      await this.apiService
          .post("resale/transaction-summary-export", this.filter)
          .then((response) => {
            response = "data:application/octet-stream;base64," + response;
            const link = document.createElement("a");
            link.href = response;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
            // this.$emit("close");
          })
          .catch((erro) => {
            this.loading = false;
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Não foi possível efetuar a exportação",
              message: erro.body.message,
              trace: null,
            });
          });
    },
    async handleRowClick(item) {
      await this.$router.push({
        path: `/order-detailresale?id=` + item.id,
        params: item,
      });
    },
    async getRransactionSummary() {
      try {
        this.prdloading = true;
        this.apiService
            .post("resale/transaction-summary", {...this.filter, page: this.page})
            .then((response) => {
              this.productSales = response.orders;
              this.totalPages = response.pager.totalPages;
              this.totalItems = response.pager.totalItems;
              this.currentPage = response.pager.currentPage;
              this.prdloading = false;
            })
            .catch(() => {
              this.prdloading = false;
            });
      } catch (e) {

      }
    },

    async backPage() {
      this.page -= 1;
      await this.getRransactionSummary();
    },

    async nextPage() {
      this.page += 1;
      await this.getRransactionSummary();
    },
  },

  watch: {
  },
};
</script>

<style>
p {


}

.aprovado {
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 5px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  padding: 5px 15px;
}

.aguardando {
  width: 100px !important;
  height: 30px !important;
  color: orange !important;
  border: 1px solid orange !important;
  box-sizing: border-box !important;
  border-radius: 5px !important;
  padding: 5px;
}

.cancelado {
  width: 100px !important;
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 5px !important;
  padding: 5px 12px;
}

</style>
